import { Pagination as DSPagination } from '@ghq-abi/design-system-v2';

import {
  Pagination as PaginationType,
  usePagination
} from '~/shared/hooks/usePagination';
import { PaginationParams } from '~/shared/types/PaginationObject';

export type PaginationBarProps = {
  queryParams: PaginationParams;
  pagination: PaginationType;
  onQueryParamsChange: (queryParams: Partial<PaginationParams>) => void;
};

export function PaginationBar({
  queryParams,
  pagination,
  onQueryParamsChange
}: PaginationBarProps) {
  const {
    totalPageCount: totalPages,
    currentPage1Based,
    pageNumbers,
    goToPage,
    nextPage,
    prevPage,
    hasPrev,
    hasNext
  } = usePagination({
    queryParams,
    pagination,
    onQueryParamsChange
  });

  if (totalPages <= 0) {
    return null;
  }

  return (
    <DSPagination.Root className="gap-1.5">
      <DSPagination.Previous
        asButton
        disabled={!hasPrev}
        onClick={() => prevPage != null && goToPage(prevPage)}
      />
      <DSPagination.Content className="gap-1.5">
        {pageNumbers.map((pageNum, index) =>
          pageNum === -1 ? (
            <DSPagination.Item key={`ellipsis-${index}`}>
              <DSPagination.Ellipsis />
            </DSPagination.Item>
          ) : (
            <DSPagination.Item key={pageNum}>
              <DSPagination.Button
                isActive={currentPage1Based === pageNum}
                onClick={() => goToPage(pageNum)}>
                {pageNum}
              </DSPagination.Button>
            </DSPagination.Item>
          )
        )}
      </DSPagination.Content>
      <DSPagination.Next
        asButton
        disabled={!hasNext}
        onClick={() => nextPage != null && goToPage(nextPage)}
      />
    </DSPagination.Root>
  );
}
